import React, { useEffect } from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import { GuidedSessionView } from "@/features/notes/(v2)/(guided-session)/GuidedSessionView";

import { PatientInfoWidget } from "./PatientInfoWidget";

export const Signoff = (componentProps) => {
  const { noteDraftSubmitHandler, noteEditHandler, noteSubmitHandler, state } = componentProps;
  const { patientDetails, patientDiagnosis, progressNote } = state;

  useEffect(() => {
    if (progressNote["call_type"]) {
      noteEditHandler("call_type", "", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let noteDisplay;

  noteDisplay = (
    <div className="m-auto">
      <GuidedSessionView
        editable
        editHandler={noteEditHandler}
        errors={state.noteErrors}
        note={progressNote}
        views={{ createEditView: true, overrideWidth: true }}
      />
    </div>
  );

  return (
    <div className="GuidedVideoCall__notes_screen">
      <PatientInfoWidget
        isLarger={true}
        patientDetails={patientDetails}
        patientDiagnosis={patientDiagnosis}
      />

      <div className="mt-3 ml-auto mr-auto tw:font-bold" style={{ maxWidth: "90%" }}>
        {progressNote.title}
      </div>

      {noteDisplay}

      <div className="d-flex my-3 mx-auto tw:justify-center">
        <div className="position-relative text-center m-3">
          <button
            className="GuidedVideoCall__center-btn fs-14"
            onClick={() => noteDraftSubmitHandler()}
            style={{ backgroundColor: "#5B57DC" }}
          >
            Save Draft
          </button>
        </div>

        <div className="position-relative text-center m-3">
          <button
            className="GuidedVideoCall__center-btn fs-14"
            onClick={() => noteSubmitHandler()}
            {...getAutomationDataAttr("Signoff_signAndSubmit")}
          >
            Sign & Submit
          </button>
        </div>
      </div>
    </div>
  );
};
